
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState, useRef } from "react";
import AkkhorLayout from "../../layout/akkhor";
import QRCode from 'qrcode.react';
import AlertErrorForm from "../../component/AlertErrorForm";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { confirmAlert } from "react-confirm-alert";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import Moment from "react-moment";
import { Spinner } from "react-bootstrap";

export default function FormCheckin() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [qrData, setQRData] = useState('');
    const qrRef = useRef(null);
    const [detail, setDetail] = useState(null);
    const [dateSelect, setDateSelect] = useState({ datestart: null, dateend: null });
    const [listUsers, setListUsers] = useState('');
    const [filteredData, setFilteredData] = useState([]) // Data sau khi lọc

    const handleChange = (e) => {
        // Thay tất cả \n thành ;
        const formatted = e.target.value.replace(/\r?\n/g, ";");
        setListUsers(formatted);
    };

    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "checkin/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                const generatedUrl = 'https://noibo.bhsgroup.vn/user_checkin/' + res.data.data.alias;
                                setDetail(res.data.data);
                                // setUrlGenerate(generatedUrl);
                                setListUsers(res.data.data.user_join)
                                setQRData(generatedUrl); // 🆕 Tạo mã QR dựa trên URL
                                const date_start = res.data.data.timestart;
                                const date_end = res.data.data.timeend;
                                setDateSelect({ datestart: date_start, dateend: date_end });
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                Axios.get(URL_LIST_ALL + "checkin_user?limit=10000000&checkin_id=" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            setFilteredData(res.data.data); // Khởi tạo dữ liệu lọc
                        } else {
                            console.log(res.data.message);
                        }
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id]
    );

    const handleDate = (name, value) => {
        formik.setFieldValue(name, moment(value).format('YYYY-MM-DD'))
        formik.setFieldTouched(name)
        let newDate = Object.assign({}, dateSelect)
        let dateSelected = null
        if (value) {
            let month = value.getMonth() + 1
            let year = value.getFullYear()
            let day = value.getDate()
            dateSelected = new Date(year + '/' + month + '/' + day + ' 00:00:00')
        }

        newDate[name] = dateSelected ? dateSelected : value
        setDateSelect(newDate)
        // console.log(value);
    };
    const formik = useFormik({
        initialValues: detail ? detail : { title: '', qr_content: '', user_id: user.data.id, qr_result: '',tantuyen:0 },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tiêu đề'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setTimeout(() => {
                values.timestart = dateSelect.datestart
                values.timeend = dateSelect.dateend

                if (listUsers && listUsers != '') {
                    values.user_join = listUsers
                }
                if (id > 0) {
                    Axios.put(URL_LIST_ALL + 'checkin/' + id, values, user.config).then(res => {
                        setSubmitting(false);
                        if (res.data.status === "success") {
                            // window.location.href = '/edit-checkin/' + id
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                } else {
                    // console.log(values);
                    Axios.post(URL_LIST_ALL + 'checkin', values, user.config).then(res => {
                        setSubmitting(false);
                        if (res.data.status === "success") {
                            window.location.href = '/edit-checkin/' + res.data.id
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                }
            }, 200);
            setSubmitting(false)
        },
    });

    const downloadQRCode = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (canvas) {
            const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            const downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = "qrcode.png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    return (
        <AkkhorLayout idrole="checkin">
            <div className="card height-auto mt-5">
                <div className="card-body">
                    <form className="new-added-form  form-info" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-sm-6 col-8 heading-layout1 mb-0">
                                <div className="item-title">
                                    <h3>Tạo mã Checkin</h3>
                                </div>
                            </div>
                            <div className="col-sm-6 col-4 d-flex justify-content-end align-items-center">
                                <button type="submit" className="btn btn-sm btn-success" >{id > 0 ? "Lưu lại" : "Tạo mã"}</button>
                            </div>
                            <div className="col-sm-6 col-12 mt-2">
                                <div className="row">
                                    <div className="col-12 form-group">
                                        <label>Nội dung <span className="text-danger">*</span></label>
                                        <input type="text" placeholder="Nhập nội dung..." className="form-control height32" {...formik.getFieldProps("title")} />
                                        <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                                    </div>
                                    <div className="col-sm-6 col-12 form-group ">
                                        <label>Ngày bắt đầu</label>
                                        <DateTimePicker onChange={(value) => { handleDate('datestart', value) }} value={dateSelect.datestart ? new Date(dateSelect.datestart) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                        <AlertErrorForm formik={formik} name="datestart"></AlertErrorForm>
                                    </div>
                                    <div className="col-sm-6 col-12 form-group ">
                                        <label>Giờ bắt đầu</label>
                                        <input type="time" className="form-control height32" {...formik.getFieldProps("time_start")} />
                                    </div>
                                    <div className="col-sm-6 col-12 form-group ">
                                        <label>Ngày kết thúc</label>
                                        <DateTimePicker onChange={(value) => { handleDate('dateend', value) }} value={dateSelect.dateend ? new Date(dateSelect.dateend) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                        <AlertErrorForm formik={formik} name="dateend"></AlertErrorForm>
                                    </div>
                                    <div className="col-sm-6 col-12 form-group ">
                                        <label>Giờ kết thúc</label>
                                        <input type="time" className="form-control height32" {...formik.getFieldProps("time_end")} />
                                    </div>
                                    <div className="col-12 form-group">
                                        <label>Nhập mã nhân viên <span className="text-danger">*</span></label>
                                        <textarea placeholder="VD: MS000011;MS000012;MS000013..." className="form-control" name="user_join" onChange={handleChange} value={listUsers} ></textarea>
                                        <AlertErrorForm formik={formik} name="user_join"></AlertErrorForm>
                                    </div>
                                    <div className="col-12 form-group">
                                        <label>Tham gia tân tuyển</label>
                                        <select className="form-select height32" {...formik.getFieldProps("tantuyen")}>
                                            <option value="0">Không</option>
                                            <option value="1">Có</option>
                                        </select>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-12">
                                <div className="row">
                                    {qrData && (
                                        <div ref={qrRef} className="mt-4">
                                            <QRCode value={qrData} size={300} />
                                        </div>
                                    )}
                                    <div className="col-12"></div>
                                    {qrData &&
                                        <div className="col-xl-4 col-lg-6 col-12">
                                            <div className="w-100 mt-2">
                                                <button type="button" className="btn btn-sm btn-primary" onClick={downloadQRCode}>
                                                    Tải ảnh xuống
                                                </button>
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </form>

                    {id > 0 && filteredData.length > 0 &&

                        <table className="table table-striped table-bordered table-hover mt-2">
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Họ tên</th>
                                    <th>Mã nhân viên</th>
                                    <th>Email</th>
                                    <th>Đơn vị</th>
                                    <th>Check-in</th>
                                    <th>Check-out</th>
                                    <th>Trạng thái</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((item, index) => (
                                    <tr key={item.user_id}>
                                        <td>{index + 1}</td>
                                        <td>{item.fullname}</td>
                                        <td>{item.code}</td>
                                        <td>{item.email}</td>
                                        <td>{item.department}</td>
                                        <td>{item.timecheckin && <Moment format="HH:mm DD/MM/YYYY">{item.timecheckin}</Moment>}</td>
                                        <td>{item.timecheckout && <Moment format="HH:mm DD/MM/YYYY">{item.timecheckout}</Moment>}</td>
                                        <td>{item.timecheckin ? "Có mặt" : "Vắng mặt"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    }
                </div>
            </div>
        </AkkhorLayout>
    );
}
